import flatMap from 'lodash-es/flatMap'
import fromPairs from 'lodash-es/fromPairs'
import { defaultSort } from './state'

const LIST_ACTION_FILTER = 'filter'
const LIST_ACTION_SORT = 'sort'

const getResultsKey = (searchProfile, sort) => {
  return `${searchProfile.tagKeys.join('-')}.${searchProfile.customTags.join('-')}.${sort}`
}

export default {
  isFilterVisible: (state) => state.listActionVisible === LIST_ACTION_FILTER,
  isSortVisible: (state) => state.listActionVisible === LIST_ACTION_SORT,

  isPageTypeJobList: (state) => state.pageType === 'JOBLIST',

  isBookmarked: (_state, { bookmarksMap }) => (jobId) => {
    return bookmarksMap[jobId]
  },
  bookmarksMap: ({ bookmarks }) => {
    return bookmarks.reduce((acc, val) => {
      acc[val] = true
      return acc
    }, {})
  },
  resultsNext ({ results }, { isResultsNextAvailable, resultsJobSelectedIndex }) {
    if (isResultsNextAvailable) {
      return results[resultsJobSelectedIndex + 1]
    } else {
      return null
    }
  },
  resultsPrev ({ results }, { isResultsPrevAvailable, resultsJobSelectedIndex }) {
    if (isResultsPrevAvailable) {
      return results[resultsJobSelectedIndex - 1]
    } else {
      return null
    }
  },
  isJobExpired ({ job }) {
    if (!job) {
      return false
    } else {
      return job.data.expired
    }
  },
  isUserFullyLoggedIn ({ user }) {
    if (!user) {
      return false
    } else {
      return user.status === 5
    }
  },
  isUserLoggedIn ({ user }) {
    if (!user) {
      return false
    } else {
      return user.status >= 4
    }
  },
  isUserKnown ({ user }) {
    return !!user && user.status >= 1
  },
  isResultsNextAvailable ({ results }, { resultsJobSelectedIndex }) {
    return resultsJobSelectedIndex + 1 !== results.length
  },
  isResultsPrevAvailable ({ results }, { resultsJobSelectedIndex }) {
    return resultsJobSelectedIndex > 0
  },
  isUserStatus: ({ user }) => (status) => {
    return user && user.status === status
  },
  resultsJobSelectedIndex ({ results, resultsJobSelected }) {
    return results.findIndex(job => job.id === resultsJobSelected)
  },
  flatTagMap ({ categories }) {
    return fromPairs(flatMap(categories, category => {
      return flatMap(category.grouped_category_tags, group => {
        return group.group_tags.map(tag => [tag.key, tag])
      })
    }))
  },
  checkedTagsMap (_state, { checkedTags }) {
    return (checkedTags && fromPairs(checkedTags.map(tag => [tag.key, tag]))) || {}
  },
  checkedTags ({ searchProfile }, { flatTagMap }) {
    return (searchProfile && searchProfile.tagKeys.map(tagKey => flatTagMap[tagKey])) || []
  },
  desiredResultsKey ({ searchProfile, sort }, { checked }) {
    return searchProfile && getResultsKey(searchProfile, sort)
  },
  resultsUpToDate: ({ resultsKey }, { desiredResultsKey }) => desiredResultsKey === resultsKey,
  jobUpToDate: ({ job, resultsJobSelected }) => !resultsJobSelected || (job && job.id === resultsJobSelected),
  isSearchProfileEmpty: ({ searchProfile }) => {
    return searchProfile && searchProfile.tagKeys.length === 0 && searchProfile.customTags.length === 0
  },
  historyStateSnapshot: ({ resultsJobSelected, resultsJobUserSelected, searchProfile, sort, pageType, jobPinned }) => {
    return { resultsJobSelected, resultsJobUserSelected, searchProfile, sort, pageType, jobPinned }
  },
  isSearchEmpty: ({ sort }, { isSearchProfileEmpty }) => sort === defaultSort && isSearchProfileEmpty
}
